import ModelVersionTrainingFormContext from './context';

const useModelVersionTrainingFormContext = () =>
  ModelVersionTrainingFormContext.hook();

export default useModelVersionTrainingFormContext;
